import { useEffect, useState } from "react";
import { API_URL } from "../../shared/constant";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import axios from "axios";
import Editor from 'react-simple-wysiwyg';

const PolicySettings = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [isError, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState({
    policy: ""
  });

  const onSave = () => {
    if (formValue.policy
    ) {
      setError(false);
      setLoading(true);
      axios
        .post(API_URL.SETTING_SAVE, formValue)
        .then((res) => {
          if (res.data.status === 1) {
            let message = id
              ? "Faqs Updated Successfully."
              : "Faqs Created Successfully.";
            toast.success(message, { autoClose: 3000, position: "top-right" });
            setLoading(false);
          }
        })
        .finally(() => {
          setLoading(false);
          setError(true);
        });
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const onEdit = () => {
    axios.post(API_URL.SETTING_SHOW, {}).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
          policy: (res.data.data.policy) ? res.data.data.policy : ""
        });
      }
    });
  };

  const isRequiredField = (key) => {
    return isError && !formValue[key];
  };

  const updateForm = (name, evt) => {
    console.log(name)
    console.log(evt.target.value)
    setFormValue({ ...formValue, [name]: evt.target.value });
  }

  useEffect(() => {
    onEdit();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>Privacy Policy</h1>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <Editor value={formValue.policy} className={
                        isRequiredField("policy")
                          ? "form-control required"
                          : "form-control"
                      } onChange={(e) => updateForm('policy', e)} />
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="form-group text-right">
                    <button
                      type="submit"
                      onClick={onSave}
                      disabled={loading}
                      className="btn btn-primary"
                    >
                      {loading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Watch color={"white"} height={20} width={20} />
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PolicySettings;